
import { Component, Vue } from 'vue-property-decorator';
import {
  promotionUnsubscribeApi,
  getNewsTypeWithUnsubscribeApi
} from '@/api/api';
import i18n from '@/lang';
@Component({
  name: 'email',
})
export default class extends Vue {
  created(){
    this.rawEmail = this.getRawQueryParam('email');
    this.getType();
  }
  public showTips:boolean=false;
  public tips:any='';
  public content:any='';
  public rawEmail:string='';

  public getRawQueryParam(key:string){
    const search = window.location.search;
    if(!search){
      return '';
    }
    const query = search.slice(1).split('&');
    for(const item of query){
      const [paramKey,...paramValue] = item.split('=');
      if(paramKey === key){
        return paramValue.join('=');
      }
    }
    return '';
  }

  public  getType(){
    this.getTypeList();
  }
  public async getTypeList(){
    const {data}:any=await getNewsTypeWithUnsubscribeApi();
    if(data.code==='1003'&&data.datas&&data.datas.length){
      const type:any=+this.$route.query.type;
      let flag=false;
      for(const item of data.datas){
        if(item.type===type){
          this.content=item.content;
          this.tips=item.tips;
          flag=true;
        }
      }
      if(!flag){
        this.tips=i18n.t('unsubscribeTips');
        this.showTips=true;
      }
    }
  }
  public async out(){
    const email:any=this.rawEmail || this.getRawQueryParam('email');
    const type:any=this.$route.query.type;
    if(!email){
      this.$message.info(i18n.t('emailTips') as any);
      return
    }
    this.$confirm(
      i18n.t('unsubscribeConfirm') as any,
      '',
    {
      confirmButtonText: i18n.t('confirm') as any,
      cancelButtonText: i18n.t('cancel') as any,
      type: 'warning',
      customClass:'emailConfirm',
    })
    .then(async () => {
      try{
        const {data}:any=await promotionUnsubscribeApi(email,type);
        if(data.code==='1003'){
          this.showTips=true;
          this.$message.success(i18n.t('unsubscribeSuccessful') as any);
        }else{
          this.$message.error(i18n.t('unsubscribeFailed') as any);
        }
      }catch(err){
        this.$message.error(i18n.t('unsubscribeFailed') as any);
      }
    }).catch(()=>{
      this.$message.info(i18n.t('canceled') as any);
    });
    
  }
}
